// GlowStrike ES — showcase video play/pause toggle + autoplay-on-scroll-into-view, matching the
// competitor's initShowcase() in theme.js. Videos are always muted (autoplay policy).
(function () {
  function initShowcase(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var playLabel = root.dataset.playLabel || 'Play video';
    var pauseLabel = root.dataset.pauseLabel || 'Pause video';

    root.querySelectorAll('.cs-showcase__card').forEach(function (card) {
      var video = card.querySelector('video');
      var toggle = card.querySelector('[data-showcase-toggle]');
      if (!video || !toggle) return;
      video.muted = true;

      function sync() {
        card.dataset.playing = String(!video.paused);
        toggle.setAttribute('aria-label', video.paused ? playLabel : pauseLabel);
      }

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      toggle.addEventListener('click', function () {
        if (video.paused) video.play().catch(function () {});
        else video.pause();
      });

      if (!reduced && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) video.play().catch(function () {});
          else video.pause();
        }, { threshold: 0.5 }).observe(card);
      }

      sync();
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-showcase]').forEach(initShowcase);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
